import { lazy } from 'react'

// Payment Links
export const PaymentLinksListPage = lazy(() =>
  import('@/features/payment-links/pages/PaymentLinksListPage').then((module) => ({
    default: module.PaymentLinksListPage,
  }))
)
export const PaymentLinkCreatePage = lazy(() =>
  import('@/features/payment-links/pages/PaymentLinkCreatePage').then((module) => ({
    default: module.PaymentLinkCreatePage,
  }))
)
export const PaymentLinkDetailsPage = lazy(() =>
  import('@features/payment-links/pages/PaymentLinkDetailsPage')
)

// Payments
export const PaymentsListPage = lazy(() => import('@features/payments/pages/PaymentsListPage'))
export const PaymentsNeedsAttentionPage = lazy(() =>
  import('@features/payments/pages/PaymentsNeedsAttentionPage')
)
export const CreatePaymentPage = lazy(() =>
  import('@features/payments/operations/create/pages/CreatePaymentPage').then((m) => ({
    default: m.CreatePaymentPage,
  }))
)
export const PaymentDetailsPage = lazy(() =>
  import('@features/payments/pages/PaymentDetailsPage')
)
export const PaymentSummaryPage = lazy(() =>
  import('@features/payments/pages/PaymentSummaryPage')
)
export const PaymentsSettingsPage = lazy(() =>
  import('@features/payments/pages/PaymentsSettingsPage').then((m) => ({
    default: m.PaymentsSettingsPage,
  }))
)
export const PaymentConfigDetailPage = lazy(() =>
  import('@features/payments/pages/PaymentConfigDetailPage').then((m) => ({
    default: m.PaymentConfigDetailPage,
  }))
)

// Payments channel pages
export const PaymentsPerformancePage = lazy(() => import('@shared/components/pages/payments-performance-page'))
export const PaymentsBinsPage = lazy(() => import('@shared/components/pages/payments-bins-page'))
export const PaymentsCostPage = lazy(() => import('@shared/components/pages/payments-cost-page'))
export const PaymentsOpportunitiesPage = lazy(() => import('@shared/components/pages/payments-opportunities-page'))
export const PaymentsNetwPage = lazy(() => import('@shared/components/pages/payments-netw-page'))
export const PaymentsUprdrPage = lazy(() => import('@shared/components/pages/payments-uprdr-page'))
export const TokensPage = lazy(() => import('@shared/components/pages/tokens-page'))
export const CheckoutPage = lazy(() => import('@shared/components/pages/checkout-page'))

// Disputes
export const DisputesListPage = lazy(() => import('@features/disputes/pages/DisputesListPage'))
export const DisputeDetailsPage = lazy(() =>
  import('@features/disputes/pages/DisputeDetailsPage')
)

// Refunds
export const RefundsListPage = lazy(() => import('@features/refunds/pages/RefundsListPage'))
export const RefundDetailsPage = lazy(() => import('@features/refunds/pages/RefundDetailsPage'))
